import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "sv",
  lng: "sv",
  resources: {
    en: {
      translations: require("./locales/en/translations.json"),
    },
    sv: {
      translations: require("./locales/sv/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    escapeValue: false,
  },
});

i18n.languages = ["en", "sv"];

export default i18n;
